export const theme = {
    default: {
        picker: {
            background: 'transparent',
            paddingTop: '0px',
            color: 'var(--g-typography-primary)',
            boxShadow: 'none'
        }
    }
};

//# sourceMappingURL=theme.js.map